/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fit_Safe_Turtle_ReviveInputs */

const fr_fit_safe_turtle_revive = /** @type {(inputs: Fit_Safe_Turtle_ReviveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edite le role et les permissions`)
};

/**

* @param {Fit_Safe_Turtle_ReviveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fit_safe_turtle_revive = /** @type {((inputs?: Fit_Safe_Turtle_ReviveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fit_Safe_Turtle_ReviveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fit_safe_turtle_revive(inputs)
});